import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router'
import {Location} from '@angular/common';
@Component({
  selector: 'app-header-back',
  templateUrl: './header-back.component.html',
  styleUrls: ['./header-back.component.css']
})
export class HeaderBackComponent implements OnInit {
	@Input('goBack') goBack: boolean
	@Input('goTo') goTo: string
	@Input('title') title: string
  @Input('buttons') buttons: any
  @Input('showSearch') showSearch: any
  @Output('searchQuery') search: EventEmitter<any> = new EventEmitter() 
  searchInput: any
  constructor(private router: Router, public _location: Location) {   	
  }

  ngOnInit() {
  }

  backClicked(){
    if (this.goTo == '/reportes/list') { 
      window.history.go(-2)
    } else {
      this._location.back();
    }        
  }

  makeClick(button){
    button.click()
  }
  changeSearch(e){
    this.search.emit(e)
  }
}
